/*
 * Okendo — estrela no formato do Figma (ion:star-sharp).
 *
 * O app publica o sprite de estrelas como <svg id="oke-star-symbols"> no topo
 * do <body> e, ao inicializar, reescreve esse elemento inteiro (outerHTML) com
 * o desenho configurado no painel dele. Por isso um sprite proprio publicado
 * pelo tema nao sobrevive — a troca precisa ser feita depois, no elemento dele.
 *
 * Aqui so trocamos o desenho (o "d" de cada path). Os ids, a estrutura e as
 * variaveis de cor continuam sendo as do Okendo, entao o que for configurado no
 * painel (ou sobrescrito em bs-okendo.css) segue valendo. O MutationObserver
 * existe para reaplicar quando o app substitui o sprite depois deste script.
 *
 * O path vem do Figma num viewBox de 10.909; o Okendo desenha cada estrela num
 * espaco de 14.6 x 14 unidades, dai o scale(1.3169). Tamanho final e
 * espacamento sao fechados em bs-okendo.css.
 *
 * Se o app mudar os ids do sprite, nada quebra: as estrelas apenas voltam ao
 * formato padrao dele.
 */
(function () {
  var STAR_PATH =
    'M10.5682 4.33168H6.6554L5.45455 0.681818L4.25369 4.33168H0.340909L3.54141 6.57742L2.29496 10.2273L5.45455 7.96534L8.61413 10.2273L7.36534 6.57742L10.5682 4.33168Z';
  var STAR_TRANSFORM = 'scale(1.3169)';

  function paintStars() {
    var sprite = document.getElementById('oke-star-symbols');

    if (!sprite) return;

    var paths = sprite.querySelectorAll('symbol path');

    for (var i = 0; i < paths.length; i++) {
      if (paths[i].getAttribute('d') === STAR_PATH) continue;

      paths[i].setAttribute('d', STAR_PATH);
      paths[i].setAttribute('transform', STAR_TRANSFORM);
    }
  }

  paintStars();

  // O app injeta e depois substitui o sprite como filho direto do <body>.
  new MutationObserver(paintStars).observe(document.body, { childList: true });
})();
